import React from 'react';
import _ from 'underscore';

import {pluralize} from 'BenchlingUtil';
import * as AssemblyConstants from 'constants/AssemblyConstants';
import * as modals from 'help/Modals';
import staticURL from 'lib/staticURL';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import pick from 'util/pick';

import AssemblyErrorIndicator from './AssemblyErrorIndicator';

const {ASSEMBLY_TYPE} = AssemblyConstants;

interface MessageProps {
  type: string;
  message: string;
}

function Message(props: MessageProps): JSX.Element {
  return (
    <div {...getTestProps({component: 'AssemblyErrorsWarnings', element: 'message'})}>
      <span className="icon">
        {(() => {
          switch (props.type) {
            case 'warning':
              return <img src={staticURL('/static/img/warning.png')} />;
            case 'success':
              return <BenchlingIcon icon="check" />;
            case 'error':
              return <BenchlingIcon icon="ban" />;
            default:
              return null;
          }
        })()}
      </span>{' '}
      {props.message}
    </div>
  );
}

interface MessagesProps {
  warnings: Array<string>;
  errors: Array<string>;
}

function Messages(props: MessagesProps): JSX.Element {
  return (
    <div className="messages selectable">
      {Array.from(props.errors).map((error) => (
        <Message type="error" message={error} key={_.uniqueId('error_')} />
      ))}
      {Array.from(props.warnings).map((warning) => (
        <Message type="warning" message={warning} key={_.uniqueId('warning_')} />
      ))}
      {props.errors.length + props.warnings.length === 0 ? (
        <Message type="success" message="Looks like everything checks out" />
      ) : undefined}
    </div>
  );
}

interface AssemblyErrorsWarningsProps {
  title?: string;
  warnings: Array<string>;
  errors: Array<string>;
  method: string;
  children?: React.ReactNode;
}

function AssemblyErrorsWarnings(props: AssemblyErrorsWarningsProps): JSX.Element {
  let title;
  if (props.title == null) {
    title = `${props.errors.length} ${pluralize(props.errors.length, 'error')} and \
${props.warnings.length} ${pluralize(props.warnings.length, 'warning')}`;
  } else {
    ({title} = props);
  }
  return (
    <AssemblyErrorIndicator {...pick(props, 'warnings', 'errors')}>
      <h4>
        {title}
        {props.method === ASSEMBLY_TYPE.GOLDEN_GATE ? (
          <a
            className={`glyphicon glyphicon-question-sign u-no-text-decoration u-small-text \
    u-tiny-spacing-left`}
            onClick={modals.showGoldenGateOverhangHelp}
          />
        ) : undefined}
      </h4>
      <Messages warnings={props.warnings} errors={props.errors} />
      {props.children}
    </AssemblyErrorIndicator>
  );
}

export default AssemblyErrorsWarnings;
